<template>
  <div class="home-body">
    <div
      class="swiper mySwiper swiper-initialized swiper-horizontal swiper-pointer-events swiper-backface-hidden col-12 banCopy gradient"
    >
      <div
        class="swiper-wrapper col-12"
        id="swiper-wrapper-0a3eaf4919af72c3"
        aria-live="off"
        style="
          transition-duration: 0ms;
          transform: translate3d(-5188px, 0px, 0px);
        "
      >
        <div
          class="swiper-slide col-12"
          role="group"
          v-for="(item, index) in getBannerData"
          :key="index"
          :aria-label="index / dataSize"
        >
          <img class="home-swiper-img" :src="item" />
        </div>
      </div>
      <div
        class="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal"
      >
        <span
          class="swiper-pagination-bullet"
          tabindex="0"
          role="button"
          aria-label="Go to slide 1"
        ></span>
        <span
          class="swiper-pagination-bullet swiper-pagination-bullet-active"
          tabindex="0"
          role="button"
          aria-label="Go to slide 2"
          aria-current="true"
        ></span>
        <span
          class="swiper-pagination-bullet"
          tabindex="0"
          role="button"
          aria-label="Go to slide 3"
        ></span>
        <span
          class="swiper-pagination-bullet"
          tabindex="0"
          role="button"
          aria-label="Go to slide 4"
        ></span>
        <span
          class="swiper-pagination-bullet"
          tabindex="0"
          role="button"
          aria-label="Go to slide 5"
        ></span>
      </div>
      <span
        class="swiper-notification"
        aria-live="assertive"
        aria-atomic="true"
      ></span>
    </div>

    <news v-if="dataSize != 0" class="newsgradient"></news>
    <business v-if="dataSize != 0" class="gradient"></business>
    <div class="backgroun-img" v-show="show"></div>

    <companies v-if="dataSize != 0 && show"></companies>
  </div>
</template>

<script>
import navbar from "../parts/navbar.vue";
import copyrightNotice from "../parts/copyrightNotice.vue";
import "../swiper/swiper-bundle.min.css";
import Swiper from "../swiper/swiper-bundle.min.js";
import news from "../parts/news.vue";
import business from "../parts/business.vue";
import companies from "../parts/companies.vue";
export default {
  name: "Swiper",
  data() {
    return {
      show: false,
      getBannerData: [],
      dataSize: 0,
    };
  },
  components: {
    news,
    business,
    companies,
    navbar,
    copyrightNotice,
  },
  mounted() {
    document.title="杭开集团";
    if (this.getBannerData.length == 0) {
      this.Post();
    }
    // 监听滚动事件
    window.addEventListener("scroll", this.scrollToTop);
    if (screen.width < 991) {
      this.show = true;
    }
  },
  beforeRouteLeave(to, form, next) {
    // 离开路由移除滚动事件
    window.removeEventListener("scroll", this.scrollToTop, true);
    next();
  },
  methods: {
    swiper() {
      var swiper = new Swiper(".mySwiper", {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        initialSlide: 0,
        spaceBetween: 30,
        centeredSlides: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        speed: 2000,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    },
    // 滚动事件
    scrollToTop() {
      // console.log(this.header_Animate);
      this.show = true;
    },
    Post() {
      var url = "http://demoapi.hkjt.cn/pages/homeSwiper.php";

      this.axios
        .get(url)
        .then((res) => {
          // console.log(res.data.length)
          var num = 0;
          var resSize = res.data.length - 1;
          for (var index = resSize; index > 0; index--) {
            // console.log(res.data[index][['seat_id']])
            // console.log(index)
            if (res.data[index]["seat_id"] == 1) {
              this.getBannerData[num] = res.data[index]["img_url"];
              num++;
            }
          }
          this.dataSize = num;
          this.$nextTick(() => {
            this.swiper();
          });
        })
        .catch((e) => {
          if (e.response) {
            //请求已发出，服务器返回状态码不是2xx。
            console.info(e.response.data);
            console.info(e.response.status);
            console.info(e.response.headers);
          } else if (e.request) {
            // 请求已发出，但没有收到响应
            // e.request 在浏览器里是一个XMLHttpRequest实例，
            // 在node中是一个http.ClientRequest实例
            console.info(e.request);
          } else {
            //发送请求时异常，捕捉到错误
            console.info("error", e.message);
          }
          console.info(e.config);
        });
    },
  },
};
</script>

<style>
@keyframes move-up {
  0% {
    opacity: 0;
    transform: translateY(+500px);
  }

  100% {
    opacity: 1;
  }
}

.companies-box {
  background-color: #fff;
  margin-bottom: 0;
  padding: 8rem 0 5rem 0;
  text-align: center;
  display: flex;
  justify-content: center;
}

.test {
  height: 1000px;
}

.news {
  background-color: #fff;
  /* display: none; */
}

.move-up {
  animation: move-up 1.5s;
}

.home-body {
  background: #eee;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 14px;
  color: #000;
  margin: 0;
  padding: 0;
}

.body-box {
  width: 100%;
}

.backgroun-img {
  position: fixed;
  top: 0;
  left: 0;
  background: url(../image/home.png) no-repeat center;
  background-size: 100%;
  width: 100vw;
  height: 100vh;
  z-index: -1;
}

.swiper {
  width: 100%;
}

.news-title-div {
  text-align: center;
  padding: 6rem 0 4rem 0;
}

.news-title-text {
  color: #363636;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.home-swiper-img {
  display: block;
  width: 100%;
  max-width: 100%;
  max-height: 100%;
  /* object-fit: cover; */
}

.swiper-pagination-bullet {
  width: 1.5rem;
  border-radius: 0;
  transition-duration: 0.8s;
  height: 0.22rem;
}

.swiper-pagination-bullet-active {
  width: 2.5rem;
  height: 0.22rem;
  border-radius: 0rem;
  transition-duration: 0.8s;
}

@media screen and (max-width: 991px) {
  .home-body {
    margin-top: 5.5rem;
  }
}

@media screen and (max-width: 576px) {
  .swiper-pagination-bullet {
    width: 0.35rem;
    border-radius: 50%;
    transition-duration: 0.8s;
    height: 0.35rem;
  }

  .swiper-pagination-bullet-active {
    width: 1rem;
    height: 0.35rem;
    border-radius: 1rem;
    transition-duration: 0.8s;
  }
}
</style>